import React, { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './header/Header';
import Categories from './categories/Categories';
import './Top.css';

// Reklam komponenti (ayrıca fayl olaraq da yaradıla bilər)
const Advertisement = ({ position, imageUrl, link, altText }) => (
  <aside className={`advertisement advertisement--${position}`} aria-label={`${position} reklam`}>
    <div className="advertisement__wrapper">
      {link ? (
        <a href={link} target="_blank" rel="noopener noreferrer" className="advertisement__link">
          <img 
            src={imageUrl} 
            alt={altText || 'Reklam banneri'} 
            className="advertisement__image"
            loading="lazy"
          />
        </a>
      ) : (
        <img 
          src={imageUrl} 
          alt={altText || 'Reklam banneri'} 
          className="advertisement__image"
          loading="lazy"
        />
      )}
    </div>
  </aside>
);

function Top() {
  const location = useLocation();

  // Kateqoriyaların gizlənəcəyi səhifələr
  const HIDDEN_CATEGORY_PATHS = [
    '/yeni-herrac',
    '/tez-tez-verilen-suallar',
    '/istifade-sertleri',
    '/mexfilik-siyaseti',
    '/elaqe',
    '/tekliflerim',
    '/bildirislerim'
  ];

  // Reklamların gizlənəcəyi səhifələr (istəyə görə)
  const HIDDEN_ADS_PATHS = [
    '/checkout',
    '/payment'
  ];

  // Məhsul detay səhifəsi pattern
  const PRODUCT_DETAIL_PATTERN = /^\/elanlar\/[^/]+\/[^/]+\/[^/]+$/;

  // Kateqoriyaların göstəriləcəyini yoxlayırıq
  const shouldShowCategories = useMemo(() => {
    const isHiddenPath = HIDDEN_CATEGORY_PATHS.includes(location.pathname);
    const isProductDetail = PRODUCT_DETAIL_PATTERN.test(location.pathname);
    const isCabinetPath = location.pathname.startsWith('/kabinetim');
    return !isHiddenPath && !isProductDetail && !isCabinetPath;
  }, [location.pathname]);

  // Reklamların göstəriləcəyini yoxlayırıq
  const shouldShowAds = useMemo(() => {
    const isHiddenAdsPath = HIDDEN_ADS_PATHS.includes(location.pathname);
    const isCabinetPath = location.pathname.startsWith('/kabinetim');
    return !isHiddenAdsPath && !isCabinetPath;
  }, [location.pathname]);

  // Reklam məlumatları (bunları API-dən də gətirə bilərsiniz)
  const advertisements = {
    left: {
      imageUrl: "/images/reklam.jpg",
      link: null,
      altText: "Sol tərəf reklam banneri",
    },
    right: {
      imageUrl: "/images/reklam.jpg",
      link: null,
      altText: "Sağ tərəf reklam banneri",
    },
  };

  // Layout class-ını dinamik təyin edirik
  const layoutClassName = useMemo(() => {
    const classes = ['page-layout'];
    if (!shouldShowAds) classes.push('page-layout--no-ads');
    return classes.join(' ');
  }, [shouldShowAds]);

  return (
    <div className={`top ${!shouldShowAds ? 'top--no-ads' : ''}`}>
      <Header />

      <div className={layoutClassName}>
        {/* Sol reklam paneli */}
        {shouldShowAds && (
          <Advertisement 
            position="left"
            imageUrl={advertisements.left.imageUrl}
            link={advertisements.left.link}
            altText={advertisements.left.altText}
          />
        )}

        {/* Əsas məzmun sahəsi */}
        <main className="main-content">
          {shouldShowCategories && <Categories />}
          <Outlet />
        </main>

        {/* Sağ reklam paneli */}
        {shouldShowAds && (
          <Advertisement 
            position="right"
            imageUrl={advertisements.right.imageUrl}
            link={advertisements.right.link}
            altText={advertisements.right.altText}
          />
        )}
      </div>
    </div>
  );
}

export default Top;